import { useLocation } from 'react-router-dom';
import { useChatboxMutation } from '../../../store/chatbox/chatboxApi'
import { useAppDispatch } from '../../../app/hooks';
import { removeChatMessage } from '../../../store/slices/chats.slice';
import { useEffect } from 'react';
import { removeObjectFromLocalStorageById, saveUniqueObjectToLocalStorage } from '../../../utils/uniqueObjectToLocalstorage';

interface IResend {
	requestId: string,
	topic: string,
	tripId: string,
	message: string,
}

const Resend = ({
	requestId,
	topic,
	tripId,
	message,
}: IResend) => {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const queryParams = new URLSearchParams(location.search);
	const action = queryParams.get('type');
	const feedbackId = queryParams.get('feedbackId');
	const [chatBoxAdd] = useChatboxMutation()

	useEffect(()=>{
		saveUniqueObjectToLocalStorage('resend', {
			requestId,
			topic,
			tripId,
			message
		});
	},[])

	const handleResend = async () => {

		setTimeout(() => {
			document.querySelector('#chatEnd')?.scrollIntoView({ behavior: 'smooth' });
		}, 300)
		removeObjectFromLocalStorageById('resend', requestId);
		dispatch(removeChatMessage(requestId))
			await chatBoxAdd(
				{ tripId: tripId || '', action: action || undefined, topic, feedbackId: feedbackId || undefined, message }
			).unwrap();
	}
	return (
		<button className='absolute -left-8 top-5' onClick={handleResend} type='button'>
			<svg className="-scale-50" xmlns="http://www.w3.org/2000/svg" version="1.1" width="32px" height="32px" xmlnsXlink="http://www.w3.org/1999/xlink">
				<g><path fill="#000000" d="M 23.5,-0.5 C 24.5,-0.5 25.5,-0.5 26.5,-0.5C 26.5,2.16667 26.5,4.83333 26.5,7.5C 23.7531,7.81335 21.0865,7.48002 18.5,6.5C 19.376,5.74917 20.376,5.24917 21.5,5C 8.88573,1.48426 2.88573,6.31759 3.5,19.5C 2.5,19.5 1.5,19.5 0.5,19.5C 0.462465,3.69399 7.96247,-1.97268 23,2.5C 23.4828,1.55198 23.6495,0.551975 23.5,-0.5 Z"/></g>
				<g><path fill="#000000" d="M 7.5,31.5 C 6.5,31.5 5.5,31.5 4.5,31.5C 4.5,28.8333 4.5,26.1667 4.5,23.5C 6.59136,23.6816 8.59136,23.3482 10.5,22.5C 13.2388,24.2308 12.9055,25.3975 9.5,26C 22.1143,29.5157 28.1143,24.6824 27.5,11.5C 28.5,11.5 29.5,11.5 30.5,11.5C 30.5569,27.2836 23.0569,32.9503 8,28.5C 7.51722,29.448 7.35055,30.448 7.5,31.5 Z"/></g>
			</svg>
		</button>
	)
}

export default Resend;